/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';

type Props = {
  title?: React.ReactNode | null;
  subtitle?: React.ReactNode;
  numSubtitleLines?: number;
};

const styles = {
  subtitle: (numSubtitleLines: number) => css`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: ${numSubtitleLines};
    -webkit-box-orient: vertical;
  `,
};

const KeyInformationDetailsItem = ({ title, subtitle, numSubtitleLines }: Props) => {
  const { enableXDPRedesignPhase1, enableXDPRedesignKIM, enableXDPRedesignHero } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || (enableXDPRedesignKIM && enableXDPRedesignHero);

  if (!title) return null;

  return (
    <div>
      <Typography2 variant={enableXDPRedesign ? 'subtitleMedium' : 'subtitleLarge'} component="div">
        {title}
      </Typography2>
      <Typography2
        variant="bodySecondary"
        component="div"
        color="supportText"
        css={numSubtitleLines && styles.subtitle(numSubtitleLines)}
      >
        {subtitle}
      </Typography2>
    </div>
  );
};

export default KeyInformationDetailsItem;
